'use client';

import type { TranslationSnapshotBoundaryComponent } from '@eliadmin/core/src/i18n/translation-snapshot-types';
import dynamic from 'next/dynamic';

const DictionaryBoundary0 = dynamic(() => import('./providers/dictionary-89b12f6345b52d31f086bfa12a9380e4df9bd3a4403770156858718b365f8085'));
const DictionaryBoundary1 = dynamic(() => import('./providers/dictionary-a62c2d3691974441a9f8493e7dd64fccbc07508ce33b70b0580eb7692fe86da3'));
const DictionaryBoundary2 = dynamic(() => import('./providers/dictionary-dc5cefa0f86a717c300d525e2c079b7a481d7bd918b07c8d83399164269eaa03'));
const DictionaryBoundary3 = dynamic(() => import('./providers/dictionary-133df795d4804cd493018c615724c5486863056285040576e9b429c64a31fd29'));
const DictionaryBoundary4 = dynamic(() => import('./providers/dictionary-7af93f13990d3659ba46c4a8c5adbf0bc394e782898d13ad28bae2024b7ef3aa'));

export const GENERATED_TRANSLATION_BOUNDARIES: Readonly<Record<string, TranslationSnapshotBoundaryComponent>> = {
  "sk": DictionaryBoundary0,
  "en": DictionaryBoundary1,
  "it": DictionaryBoundary2,
  "de": DictionaryBoundary3,
  "hu": DictionaryBoundary4,
};
